module.exports = __webpack_public_path__ + "static/media/macb.ce3c5e96.png";